import { Carrier } from '../Carrier';

export class PreferredCarrier {
  id?: number;
  carrier?: Carrier;
  priority?: number;

  constructor(opts?: Partial<PreferredCarrier>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.carrier != null) {
      this.carrier = new Carrier(opts.carrier);
    }
    if (opts?.priority != null) {
      this.priority = opts.priority;
    }
  }
}
